import avisoRepository from './avisoRepository'
import chamadaRepository from './chamadaRepository'
import encaminhamentoRepository from './encaminhamentoRepository'
import filaAtendimentoRepository from './filaAtendimentoRepository'
import filaRepository from './filaRepository'
import opcaoChamadaRepository from './opcaoChamadaRepository'
import opcaoEntradaRepository from './opcaoEntradaRepository'
import parametrizacaoRepository from './parametrizacaoRepository'
import prioridadeRepository from './prioridadeRespository'
import telaRepository from './telaRepository'
import tempoEsperaRepository from './tempoEsperaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/painel-senha`

    return {
        chamada: chamadaRepository(baseUrl),
        encaminhamento: encaminhamentoRepository(baseUrl),
        fila: filaRepository(baseUrl),
        filaAtendimento: filaAtendimentoRepository(baseUrl),
        opcaoChamada: opcaoChamadaRepository(baseUrl),
        opcaoEntrada: opcaoEntradaRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        prioridade: prioridadeRepository(baseUrl),
        tela: telaRepository(baseUrl),
        tempoEspera: tempoEsperaRepository(baseUrl),
        aviso: avisoRepository(baseUrl),
    }
}